<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="分类：">
            <el-select size="medium" v-model="searchForm.CATALOG_ID" clearable filterable>
              <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择" clearable>
              <el-option v-for="item in companyLists" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" unlink-panels v-model="searchForm.DATE" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="查询类型：">
            <el-select size="medium" filterable v-model="searchForm.查询类型" placeholder="请选择" clearable>
              <el-option v-for="item in 毛利表查询类型" :key="item.Stype" :label="item.NAME" :value="item.Stype"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="$_fliterData">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="$_exportForm">导出</el-button>
            <!-- <el-button class="btn" @click="$_exportDetail">导出明细</el-button> -->
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" prop="INDEX" width="50px"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
          <el-table-column label="产品名称" prop="NAME" min-width="100px"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100px"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="100px"></el-table-column>
          <el-table-column label="销售数量" prop="SALE_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="销售均价" prop="SALE_PRICE" min-width="100px"></el-table-column>
          <el-table-column label="收入金额" prop="SALE_TOTAL_FEE" min-width="100px"></el-table-column>
          <el-table-column label="出库数量" prop="PURCHASE_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="成本均价" prop="PURCHASE_PRICE" min-width="100px"></el-table-column>
          <el-table-column label="成本金额" prop="PURCHASE_TOTAL_FEE" min-width="100px"></el-table-column>
          <el-table-column label="毛利" prop="PROFIT" min-width="100px"></el-table-column>
          <el-table-column label="毛利率" prop="GROSS_MARGIN" min-width="100px"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                     layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { selectTCFun } from 'api/sellOrder';
import http from '@/assets/common/http';
import { getClassFun } from '@/assets/api/skuManage';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      searchForm: {
        DATE: [`${date(new Date(), '%F').slice(0, -2)}01`, date(new Date(), '%F')],
      },
      tableData: [],
      kinds: [],
      customer: [],
      companyLists: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      catalogList: [],
      毛利表查询类型: this.$util.毛利表查询类型(),
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.searchForm = { ...this.searchForm, ...this.$store.state.SINGLERANGE_ALL };
    // this.getDate();
    this.queryData();
    this.queryPro();
    this.queryCatalog();
  },
  methods: {
    queryCatalog() {
      getClassFun().then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // ----拉取项目点
    queryPro() {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.companyLists = this.$util.listRemoveDuplicates(result[0].company);
        } else {
          this.companyLists = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出
    $_exportForm() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 39,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      [params.START_DAY, params.END_DAY] = [...this.searchForm.DATE];
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    $_exportDetail() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 48,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      [params.START_DAY, params.END_DAY] = [...this.searchForm.DATE];
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    $_fliterData() {
      this.currentPage = 1;
      this.queryData();
    },
    // 获取界面数据
    queryData() {
      this.$store.dispatch('SINGLERANGE_ALL', {
        ...this.searchForm,
      });
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 40,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      [params.START_DAY, params.END_DAY] = [...this.searchForm.DATE];
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      http.post(params).then((result) => {
        if (result.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else if (result.length != 0) {
          this.tableData = result[0].list.map((item, index) => ({ ...item, INDEX: index + 1 }));
          this.tableData[this.tableData.length - 1] = {
            ...this.tableData[this.tableData.length - 1],
            INDEX: '合计',
            NAME: '',
            SALE_PRICE: '',
            PURCHASE_PRICE: '',
          };
          this.totalCount = result[0].TOTAL;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getDate() {
      const start = `${date(new Date(), '%F').slice(0, -2)}01`;
      const end = date(new Date(), '%F');
      this.searchForm.DATE = [start, end];
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tableManage/singleRange.vue